import { useState, FormEvent } from 'react';
import { useTranslation } from 'react-i18next';

export default function EmailSignup() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    
    if (!email || !email.includes('@')) {
      return;
    }

    setIsSubmitting(true);

    try {
      const formData = new URLSearchParams();
      formData.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d4n99hphk4g2rg9v07pg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString(),
      });

      if (response.ok) {
        setShowSuccess(true);
        setEmail('');
        setTimeout(() => setShowSuccess(false), 5000);
      }
    } catch (error) {
      console.error('Form submission error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="signup" className="relative py-32 px-6">
      <div className="max-w-4xl mx-auto">
        <div className="relative p-12 lg:p-16 rounded-3xl bg-gradient-to-br from-teal-900/30 to-emerald-900/30 border border-teal-500/30 backdrop-blur-sm overflow-hidden">
          {/* Ambient Effects */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-teal-500/10 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-emerald-500/10 rounded-full blur-3xl"></div>

          <div className="relative text-center space-y-8">
            <div className="space-y-4">
              <h2 className="text-4xl lg:text-5xl font-bold text-white font-['Space_Grotesk']">
                {t('signup.title')}
              </h2>
              <p className="text-xl text-slate-300 max-w-2xl mx-auto">
                {t('signup.subtitle')}
              </p>
            </div>

            <form 
              id="early-access-form"
              data-readdy-form
              onSubmit={handleSubmit}
              className="max-w-md mx-auto space-y-4"
            >
              <div className="flex flex-col sm:flex-row gap-4">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder={t('signup.emailPlaceholder')}
                  required
                  className="flex-1 px-6 py-4 bg-slate-900/50 border border-slate-700 rounded-lg text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all"
                />
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="px-8 py-4 bg-gradient-to-r from-teal-500 to-emerald-500 text-white font-semibold rounded-lg hover:from-teal-600 hover:to-emerald-600 transition-all duration-300 shadow-lg shadow-teal-500/25 hover:shadow-teal-500/40 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
                >
                  {isSubmitting ? t('signup.submitting') : t('signup.button')}
                </button>
              </div>

              {showSuccess && (
                <div className="p-4 bg-teal-500/20 border border-teal-500/40 rounded-lg">
                  <p className="text-teal-300 font-medium">
                    {t('signup.success')}
                  </p>
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
